// @flow strict

import React from 'react';
import styles from './styles.scss';

type StepsType = {|
  order: number,
  message: string,
|};

const Stepper = (props: StepsType) => {
  return (
    <div>
      <h4 className={styles.stepperHeader}>Step - {props.order}</h4>
      <p className={styles.stepperMessage}>{props.message}</p>
    </div>
  );
};

export default Stepper;
